import React, { ReactNode } from 'react';

type MapButtonProps = {
  onClick: () => void;
  children: ReactNode;
};

export const MapButton = ({ onClick, children }: MapButtonProps) => {
  return (
    <button
      className={`px-2 py-1 pointer-events-auto rounded-lg bg-neutral-50/90 text-indigo-600 text-base
            border-indigo-600 border-2 hover:text-indigo-800 hover:border-indigo-800 w-fit`}
      onClick={onClick}
    >
      {children}
    </button>
  );
};
